export const mapPetsOfferParams = (offer) => ({
  offerId: offer.id,
  moduleId: offer.moduleId || offer.module?.id,
  price: offer.pricing?.basePrice || null,
  companyId: offer.company?.id,
  allowedDocuments: offer.documents?.allowedTypes || null,
});

export const mapPetsOrderToState = (order, options = {}) => {
  if (!order) return null;

  const info = order.info || order.insurant || {};
  const offer = order.offer || options.offer || {};
  const insuranceObject = order.insuranceObject || {};

  return {
    policyholder: {
      id: info.id || null,
      fullName: info.name_ua ? { fullNameUa: info.name_ua, partsUa: info.name_ua.split(' ').filter(Boolean) } : null,
      taxNumber: info.identificationCode || null,
      withoutTaxNumber: info.withoutIdentificationCode || false,
      email: info.mail || null,
      phone: info.phone || null,
      dateOfBirth: info.dateBirth || null,
      address: info.city ? {
        region: null,
        city: info.city,
        street: info.street ? { nameUa: info.street } : null,
        buildingNumber: info.house || null,
        apartmentNumber: info.apartment || null,
      } : null,
    },
    pet: {
      petType: insuranceObject.petType || null,
      petBreed: insuranceObject.petBreed || null,
      petSex: insuranceObject.petSex || null,
      petAlias: insuranceObject.petAlias || null,
      petBirthDate: insuranceObject.petBirthDate || null,
    },
    vetPassport: {
      serial: insuranceObject.vetPassportSerial || null,
      number: insuranceObject.vetPassportNumber || null,
      date: insuranceObject.vetPassportDate || null,
      issuedBy: insuranceObject.vetPassportIssuedBy || null,
    },
    microchip: {
      code: insuranceObject.microchipCode || null,
      date: insuranceObject.microchipDate || null,
    },
    contract: {
      startDate: order.startDate || null,
      estimatedPeriod: offer.insurancePeriod || null,
    },
    offer: offer || null,
    orderId: order.id || null,
    insuranceAmount: insuranceObject.insuranceAmount || order.insuranceAmount || null,
    insurancePeriod: insuranceObject.insurancePeriod || order.insurancePeriod || null,
    earnings: insuranceObject.earnings || order.earnings || null,
  };
};
